import {action} from 'easy-peasy';
export default {
  setPackage: action((state, payload) => {
    state.packageId = payload.packageId;
    state.isCustom = payload.isCustom;
  }),
  clearPackage: action((state) => {
    state.packageId = null;
    state.isCustom = null;
  }),
};
